export const laegeuddannelsenUrl = "https://www.laegeuddannelsen.dk/forside/uddannelseslaegedk.aspx";
export const landingPageInfoUrl = "https://www.laegeuddannelsen.dk/forside/uddannelseslaegedk.aspx";
export const erhvervsstyrelsesCookieBekendtgørelseUrl = "https://digst.dk/sikkerhed/digitale-tilsyn/tilsyn-med-sporingsteknologiomraadet/cookievejledningen/";
export const minecookiesUrl = "http://minecookies.org/cookiehandtering/";
export const googleAnalyticsUrl = "https://tools.google.com/dlpage/gaoptout";
export const tilgaengelighedsErklaeringUrl = "https://www.was.digst.dk/uddannelseslaege-dk";
